const APP_CATEGORIES = [
  {
    id: 'sales_channels',
    label: 'Sales channels',
    description: `Sell in stores, on marketplaces and wherever your customers are.`,
    categories: [
      {
        id: 'selling_in_person',
        label: 'Selling in person',
        categories: [
          {
            id: 'retail',
            label: 'Point of sale',
          },
          {
            id: 'sku_and_barcodes',
            label: 'SKU and barcodes',
          },
          {
            id: 'store_locator',
            label: 'Store locator',
          },
        ],
      },
      {
        id: 'selling_online',
        label: 'Selling online',
        categories: [
          {
            id: 'marketplaces',
            label: 'Marketplaces',
          },
          {
            id: 'product_feeds',
            label: 'Product feeds',
          },
          {
            id: 'social_commerce',
            label: 'Social commerce',
          },
        ],
      },
    ],
  },
  {
    id: 'finding_products',
    label: 'Finding products',
    description: `Source products to sell without making them yourself.`,
    categories: [
      {
        id: 'dropshipping',
        label: 'Dropshipping',
      },
      {
        id: 'print_on_demand',
        label: 'Print on demand',
      },
      {
        id: 'wholesale',
        label: 'Wholesale',
      },
    ],
  },
  {
    id: 'selling_products',
    label: 'Selling products',
    description: `More kinds of products, more ways to pay.`,
    categories: [
      {
        id: 'custom_products',
        label: 'Custom products',
        categories: [
          {
            id: 'custom_file_upload',
            label: 'Custom file upload',
          },
          {
            id: 'product_variants',
            label: 'Product variants',
          },
        ],
      },
      {
        id: 'digital_goods_and_services',
        label: 'Digital goods and services',
        categories: [
          {
            id: 'digital_products',
            label: 'Digital products',
          },
          {
            id: 'event_booking',
            label: 'Event booking',
          },
          {
            id: 'nfts_and_tokengating',
            label: 'NFTs and tokengating',
          },
        ],
      },
      {
        id: 'payment_options',
        label: 'Payment options',
        categories: [
          {
            id: 'cash_on_delivery',
            label: 'Cash on delivery (COD)',
          },
          {
            id: 'payments',
            label: 'Payments',
          },
          {
            id: 'subscriptions',
            label: 'Subscriptions',
          },
        ],
      },
      {
        id: 'pricing',
        label: 'Pricing',
        categories: [
          {
            id: 'pricing_optimization',
            label: 'Pricing optimization',
          },
          {
            id: 'pricing_quotes',
            label: 'Pricing quotes',
          },
        ],
      },
    ],
  },
  {
    id: 'orders_and_shipping',
    label: 'Orders and shipping',
    description: `Get orders out the door.`,
    categories: [
      {
        id: 'orders',
        label: 'Orders',
        categories: [
          {
            id: 'invoices_and_receipts',
            label: 'Invoices and receipts',
          },
          {
            id: 'order_editing',
            label: 'Order editing',
          },
          {
            id: 'order_tracking',
            label: 'Order tracking',
          },
        ],
      },
      {
        id: 'returns_and_warranty',
        label: 'Returns and warranty',
        categories: [
          {
            id: 'returns_and_exchanges',
            label: 'Returns and exchanges',
          },
          {
            id: 'warranties_and_insurance',
            label: 'Warranties and insurance',
          },
        ],
      },
      {
        id: 'shipping_solutions',
        label: 'Shipping solutions',
        categories: [
          {
            id: 'delivery_and_pickup',
            label: 'Delivery and pickup',
          },
          {
            id: 'shipping',
            label: 'Shipping',
          },
          {
            id: 'shipping_rates',
            label: 'Shipping rates',
          },
          {
            id: 'third_party_logistics',
            label: 'Third-party logistics (3PL)',
          },
        ],
      },
    ],
  },
  {
    id: 'marketing_and_conversion',
    label: 'Marketing and conversion',
    description: `Get more customers and make more sales.`,
    categories: [
      {
        id: 'advertising',
        label: 'Advertising',
      },
      {
        id: 'email_and_sms',
        label: 'Email and SMS',
      },
      {
        id: 'loyalty_and_rewards',
        label: 'Loyalty and rewards',
      },
      {
        id: 'reviews',
        label: 'Reviews',
      },
      {
        id: 'search_and_discovery',
        label: 'Search and discovery',
      },
      {
        id: 'seo',
        label: 'SEO',
      },
    ],
  },
  {
    id: 'store_design',
    label: 'Store design',
    description: `Make your store look great.`,
    categories: [
      {
        id: 'themes',
        label: 'Themes',
      },
      {
        id: 'page_builders',
        label: 'Page builders',
      },
      {
        id: 'content_and_media',
        label: 'Content and media',
      },
    ],
  },
  {
    id: 'store_management',
    label: 'Store management',
    description: `Run the business behind your store.`,
    categories: [
      {
        id: 'admin_tools',
        label: 'Admin tools',
      },
      {
        id: 'analytics_and_reporting',
        label: 'Analytics and reporting',
      },
      {
        id: 'customer_support',
        label: 'Customer support',
      },
      {
        id: 'inventory',
        label: 'Inventory',
        categories: [
          {
            id: 'erp',
            label: 'ERP',
          },
          {
            id: 'inventory_optimization',
            label: 'Inventory optimization',
          },
          {
            id: 'inventory_sync',
            label: 'Inventory sync',
          },
        ],
      },
      {
        id: 'store_data_importer',
        label: 'Store data importer',
      },
    ],
  },
];

module.exports = {
  APP_CATEGORIES,
};
